export const analyzerTypesMiddleware = (
  name: string,
  value: string,
  state: any,
  autoboxValue?: object,
  autoboxLabel?: string
) => {
  if (autoboxLabel) {
    if (autoboxLabel === "hardwareCategory")
      return { hardwareCategory: autoboxValue };
  }
  return {};
};
